













































































import { namespace } from 'vuex-class';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import Button from '@/shared/components/Button/Button.vue';
import Divider from '@/shared/components/Divider/Divider.vue';
import ButtonBack from '@/shared/components/Button/ButtonBack.vue';
import EarlyRenewal from '@/shared/components/EarlyRenewal/EarlyRenewal.vue';
import ReCAPTCHABranding from '@/shared/components/ReCAPTCHABranding/ReCAPTCHABranding.vue';

import { executeCaptcha } from '@/helpers/captcha';
import { EPaymentMethod, EEligibilityAction, ECardStep, EPaymentMethodTypes } from '@/helpers/enums';
import { EBankSlipInstallmentSteps } from '@/shared/enums/EBankSlipInstallmentSteps';
import { sendInteractEvent } from '@/helpers/events';

import { IPayment } from '@/interfaces/Payment';
import {
  ICheckoutCartOffer,
  ICheckoutCartOfferEligibility,
} from '@/interfaces/Checkout';
import { ICreditCard } from '@/interfaces/CreditCard';
import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';

import { Payment } from '@/classes/Checkout/Payment';

import { addScriptKoin, removeScriptKoin, getKoinFraudIDByScript } from '@/helpers/dom';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');
const BehaviorModule = namespace('App/Behavior');

declare global {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  interface Window {
    koin: any;
    GetKoinFraudID: any;
  }
}

@Component({
  components: {
    Button,
    Divider,
    ButtonBack,
    EarlyRenewal,
    ReCAPTCHABranding,
  },
})
export default class PaymentActions extends Vue {
  @Prop()
  private readonly isUpsell!: boolean;

  @Prop({ default: true })
  private recaptcha!: boolean;

  @Prop()
  private readonly validatePaymentType!: Function;

  @AppModule.State
  private paymentMethodSelected: string;

  @AppModule.Mutation
  private setStepFormSelected: Function;

  @CheckoutModule.Getter
  private readonly bankSlipAcceptedTermsChecked!: boolean;

  @CheckoutModule.Getter('selectedOffer')
  private offer!: ICheckoutCartOffer;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment!: Payment;

  @CheckoutModule.Getter
  private disablePurchaseKoin!: boolean;

  @CheckoutModule.Getter
  private bankSlipInstallmentSelected!: any;

  @CheckoutModule.Getter
  private isRenewal!: boolean;

  @CheckoutModule.Getter
  private bankSlipStep!: string;

  @CheckoutModule.Action
  private selectOfferPaymentMethodType!: (options: { offer_id?: number, type: EPaymentMethodTypes })=> IPayment;

  @CheckoutModule.Action('buy')
  protected finishPurchase!: Function;

  @CheckoutModule.Action
  protected getKoinFraudId!: Function;

  @CheckoutModule.Action('buyUpsell')
  protected finishPurchaseUpsell!: Function;

  @CheckoutModule.Mutation('selectOfferPaymentCardStep')
  private selectOfferPaymentCardStep!: (options: { offer_id?: number, step: ECardStep })=> IPayment;

  @CheckoutModule.Mutation
  private readonly toggleModalPayment!: Function;

  @CheckoutModule.Mutation
  private readonly setFraudId!: Function;

  @CheckoutModule.Mutation
  private selectPaymentConditionId!: Function;

  @CheckoutModule.Mutation
  private selectMainPaymentCondition!: Function;

  @CheckoutModule.Mutation
  private selectSecondPaymentCondition!: Function;

  @CheckoutModule.State
  private paymentConditionIdSelected: number | null;

  @CheckoutModule.State
  private mainPaymentCondition: any | null;

  @CheckoutModule.State
  private secondPaymentCondition: any | null;

  @CheckoutModule.State('offerLoading')
  private loading!: boolean;

  @CheckoutModule.State
  private creditCard: any;

  @AppModule.Mutation
  private setCardSelected: Function;

  @AppModule.State
  private stepFormSelected: any;

  @BehaviorModule.Action
  private setCaptchaValid: Function;

  @BehaviorModule.Getter
  private isCaptchaValid: boolean;

  @BehaviorModule.State
  private canPay: boolean;

  private goBack() {
    this.setCardSelected(null);
    this.choosePaymentCardStep(this.paymentCardSteps.select);
  }

  private choosePaymentMethodType (type: EPaymentMethodTypes) {
    this.selectOfferPaymentMethodType({
      offer_id: this.offer.id,
      type,
    });
  }

  private choosePaymentCardStep (step: ECardStep) {
    this.selectOfferPaymentCardStep({
      offer_id: this.offer.id,
      step,
    });
  }

  private dispatchStatus (status: string) {
    this.$emit(status);
  }

  private async setfraudIdKoin() {
    if(this.bankSlipAcceptedTermsChecked) {
      await getKoinFraudIDByScript();
      await this.setFraudId(window.koin);
      await removeScriptKoin();
    }
  }

  private async buy () {
    const type: EPaymentMethodTypes = this.payment.selectedPaymentType;
    await this.selectPaymentConditionId({
      offer_id: this.offer.id,
      payment_condition_id: this.paymentConditionIdSelected,
      payment_method: EPaymentMethod[type],
    });

    this.selectMainPaymentCondition({
      offer_id: this.offer.id,
      main_payment_condition: this.mainPaymentCondition,
    });

    this.selectSecondPaymentCondition({
      offer_id: this.offer.id,
      second_payment_condition: this.secondPaymentCondition,
    });

    await this.setfraudIdKoin();

    const canBuy = await this.validatePaymentType({
      type: this.payment.selectedPaymentType,
      step: this.paymentMethodCardStep
    });

    if (canBuy) {
      this.setStepFormSelected(null);
      const purchaseFunction = this.isUpsell
        ? this.finishPurchaseUpsell
        : this.finishPurchase;

      try {
        await purchaseFunction();

        this.dispatchStatus('success');
      } catch(_) {
        this.dispatchStatus('failure');
      }
    }
  }

  private paymentTypeIsActive (paymentType: EPaymentMethodTypes) {
    return this.payment.selectedPaymentType === paymentType;
  }

  public paymentTypeIsAvailable (paymentType: EPaymentMethodTypes) {
    return this.payment.paymentTypeIsAvailable(paymentType);
  }

  private get hasCards (): boolean {
    return this.payment.cards.options.length > 0;
  }

  private get paymentCardSteps () {
    return ECardStep;
  }

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get paymentMethodTypes(): any {
    return EPaymentMethodTypes;
  }

  private get paymentMethodCardStep (): ECardStep | undefined {
    const paymentMethod =  this.payment.getPaymentMethod(EPaymentMethod.creditCard);

    return paymentMethod && paymentMethod.step;
  }

  private get isEmpiricusGift() {
    return this.$route.query.g === '1';
  }

  private get bankSlipInstallmentSteps() {
    return EBankSlipInstallmentSteps;
  }

  private get isBankSlipInstallmentsStepInstallment() {
    return this.bankSlipStep === this.bankSlipInstallmentSteps.loading;
  }

  private get showActionButtons() {
    return this.bankSlipStep === this.bankSlipInstallmentSteps.initial || this.bankSlipInstallmentSelected;
  }

  private get isMultiPaymentCreditCardActived() {
    return this.paymentTypeIsActive(this.paymentMethodTypes.creditCard) && this.creditCard && this.creditCard.filterActived && this.creditCard.filterActived !== 'single-credit-card';
  }

  private get buyButtonLabel() {
    return `${this.isRenewal ? 'Renovar' : 'Comprar'}${this.isMultiPaymentCreditCardActived ? '' : ' com 1-clique'}`;
  }

  private mounted() {
    executeCaptcha(this.payment.selectedPaymentType)
      .then((success: boolean) => {
        this.setCaptchaValid(success);
      });
  }
}
